import { type Transform }  from "silver";
import { ImageBand, type ImageBandImageConfiguration } from "core/Controls/ImageBand";
import { type MyonLanguageLoader } from "Lang";

export interface ImageBandConfiguration {
	bandType: number;
	bandTitle: string;
	images: ImageBandImageConfiguration[];
	isImage: true;
}

export class ImageBandService {
	constructor(
		private transform: Transform,
		private lang: MyonLanguageLoader
	) {	}

	public makeFromConfig(config: ImageBandConfiguration): ImageBand {
		const imageBand = new ImageBand(
			config.bandTitle,
			this.transform
		);
		imageBand.setImageData(config.images);
		this.lang.load("Pages\\Library\\Recommended").then((recommendedLang) => {
			imageBand.setLang(recommendedLang);
		});

		return imageBand;
	}
}
